interface RatingStarsProps {
  value: number; // 0 - 10
  size?: "sm" | "md";
  showValue?: boolean;
}

export default function RatingStars({
  value,
  size = "sm",
  showValue = true,
}: RatingStarsProps) {
  const five = value / 2;
  const full = Math.floor(five);
  const hasHalf = five - full >= 0.5;
  const starClass = size === "md" ? "text-base" : "text-xs";

  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={`flex items-center gap-0.5 text-accent-500 ${starClass}`}>
        {[0, 1, 2, 3, 4].map((i) => {
          if (i < full) return <i key={i} className="ri-star-fill"></i>;
          if (i === full && hasHalf)
            return <i key={i} className="ri-star-half-fill"></i>;
          return <i key={i} className="ri-star-line text-secondary-300"></i>;
        })}
      </span>
      {showValue && (
        <span className="font-label text-xs font-semibold text-foreground-700">
          {value.toFixed(1)}
        </span>
      )}
    </span>
  );
}